/**
 * Convert values between the units to make sure the resulting element
 * rendering isn't changing visually (not jumping). Covert from px to %,
 * em, vh, relative and back.
 *
 * Conversion formulas are different for font-based and non-font properties.
 *
 * @param {number} valueToCovert	Value to convert
 * @param {string} unitFrom			Current unit name ('px', '%', etc.).
 * @param {string} unitInto			Unit name needed ('px', '%', etc.).
 * @returns {number}				Coverted value
 */
export default ( { valueToCovert, unitFrom, unitInto, cssProperty, selectedEl = window.Stylist.selectedEl } = atributes ) => {
	let result = valueToCovert
	// const cssProperty = this.props.cssProperty
	const fontRelatedSizing = isFontRelatedProperty( cssProperty )
	// ↑ Can be true / false

	const widthRelatedToCurrent = isWidthRelatedToCurrent( cssProperty )
	const currentFontSize = parseInt( getComputedStyle( selectedEl ).fontSize )
	const parentFontSize = parseInt( getComputedStyle( selectedEl.parentNode ).fontSize )

	const currentElWidth = parseInt( getComputedStyle( selectedEl ).width )
	let parentElWidth = parseInt( getComputedStyle( selectedEl.parentNode ).width )
	if ( ! parentElWidth ) {
		parentElWidth = 0
	}

	if ( 'string' === typeof valueToCovert && valueToCovert.includes( 'em' ) ) {
		unitFrom = 'em'
		valueToCovert = parseFloat( valueToCovert )
	}

	/**
	 * In some situations (like for font-size and line-height)
	 * value will not convert using the same formula.
	 * This is why we need to feed conversion formula with different data
	 * to have expected output.
	 */
	let relativeFontSize = parentFontSize

	if ( 	'line-height' === cssProperty ||
			'letter-spacing' === cssProperty ||
			'word-spacing' === cssProperty ||
			'text-indent' === cssProperty ||

			'border-width' === cssProperty ||
			'border-top-width' === cssProperty ||
			'border-right-width' === cssProperty ||
			'border-bottom-width' === cssProperty ||
			'border-left-width' === cssProperty ) {
		relativeFontSize = currentFontSize
	}

	let relativeElWidth = parentElWidth

	if ( widthRelatedToCurrent ) {
		relativeElWidth = currentElWidth
	}

	if ( 'px' === unitFrom ) {
		// Convert px to em.
		if ( 'em' === unitInto ) {
			result = ( valueToCovert / relativeFontSize ).toFixed( 4 )
		}

		// Convert px to %.
		if ( '%' === unitInto ) {
			if ( fontRelatedSizing ) {
				result = ( valueToCovert / parentFontSize * 100 ).toFixed( 2 )
			} else {
				result = ( valueToCovert / relativeElWidth * 100 ).toFixed( 2 )

				/* if ( 'background-position-x' === cssProperty ) {
					result = result * 2
				} */
			}
		}

		// Convert px to relative.
		if ( '' === unitInto ) {
			result = ( valueToCovert / relativeFontSize ).toFixed( 3 )
		}
	}

	if ( '%' === unitFrom ) {
		if ( 'em' === unitInto ) {
			// Convert px to em.
			if ( fontRelatedSizing ) {
				result = ( valueToCovert / 100 * parentFontSize / relativeFontSize ).toFixed( 3 )
			} else {
				result = ( valueToCovert / 100 * relativeElWidth / relativeFontSize ).toFixed( 3 )
				// If change this formula check text-indent property
			}
		}

		// Convert px to %.
		if ( 'px' === unitInto ) {
			if ( fontRelatedSizing ) {
				result = parseInt( valueToCovert / 100 * parentFontSize )
			} else {
				result = parseInt( relativeElWidth / 100 * valueToCovert )
			}
		}
	}

	if ( 'em' === unitFrom ) {
		if ( 'px' === unitInto ) {
			// Convert em to px.
			// If change: check border width coversion!
			// if ( fontRelatedSizing ) {
			result = ( valueToCovert * relativeFontSize ).toFixed( 3 )
			/* } else {
				result = parseInt( valueToCovert * parentElWidth )
			} */
		}

		if ( '%' === unitInto ) {
			// Convert em to %.
			// result = ( valueToCovert * relativeFontSize / parentFontSize * 100 ).toFixed( 1 )
			if ( fontRelatedSizing ) {
				result = ( valueToCovert * relativeFontSize / parentFontSize * 100 ).toFixed( 1 )
			} else {
				result = ( valueToCovert * relativeFontSize / relativeElWidth * 100 ).toFixed( 1 )
			// ! parentElWidth needed for text-indent, not sure about other.
			}
		}

		if ( '' === unitInto ) {
			// Convert px to relative.
			result = ( valueToCovert * relativeFontSize / relativeFontSize ).toFixed( 3 )
		}
	}

	if ( '' === unitFrom ) {
		if ( 'px' === unitInto ) {
			// Convert relative to px.
			result = parseInt( valueToCovert * relativeFontSize )
		}

		if ( '%' === unitInto ) {
			// Convert em to %.
			result = parseInt( valueToCovert / parentFontSize * 100 ).toFixed( 1 )
		}

		if ( 'em' === unitInto ) {
			// Convert px to relative.
			result = ( valueToCovert * parentFontSize / parentFontSize ).toFixed( 3 )
		}
	}

	return result
}

/**
 * Return true if the current property type sizing type is font-based.
 *
 * @param {string} property – Property to test.
 * @return {boolean} True if the property is font-related.
 */
const isFontRelatedProperty = ( property ) => {
	switch ( property ) {
		case 'font-size':
		case 'line-height':
		case 'font-weight':
		case 'letter-spacing':
		case 'word-spacing':
			return true

		default:
			return false
	}
}

const isWidthRelatedToCurrent = ( property ) => {
	switch ( property ) {
		case 'background-position-x':
		case 'background-position-y':
			return true

		default:
			return false
	}
}



// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/convert-units.js